import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { LoadingModel } from 'app/models/shared/loading.model';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrl: './confirm-modal.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmModalComponent {
  @Input() width = 448;
  @Input() height = 548;
  @Input() isConfirming = false;
  @Input() title = '';
  @Input() message = '';
  @Input() bigIcon = true;
  @Input() confirmBtnText = 'Confirm';
  @Input() cancelBtnText = 'Cancel';
  @Input() textCenter = true;
  @Input() loadingData: LoadingModel = new LoadingModel();

  
  @Output() readonly visibleChange = new EventEmitter<boolean>();
  @Output() readonly onConfirm = new EventEmitter<boolean>();

  private _visible = false;
  @Input() 
  get visible(): boolean {
    return this._visible;
  };
  set visible(value: boolean) {
    this._visible = value;
    if (!value) {
      this.isConfirming = false;
    }
    this.visibleChange.emit(value);
  }

  handleConfirm() {
    this.isConfirming = true;
    this.onConfirm.emit(true);
  }

  handleCancel() {
    this.visible = false;
    this.onConfirm.emit(false);
  }
}
